import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API, API_ROUTES } from '@app/shared/utils/api-routes';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { EditedInvoice } from '@app/shared/interfaces/edited-invoice.inteface';

@Injectable({
  providedIn: 'root',
})
export class EditedInvoiceService {
  constructor(private http: HttpClient) {}

  public importEditedInvoices(files: string[]): Observable<unknown> {
    return this.http.post(`${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.EDITED_INVOICES}`, files);
  }

  public deleteEditedInvoices(invoices: Partial<EditedInvoice>[]): Observable<unknown> {
    return this.http
      .delete(`${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.INVOICE}?edited=true`, {
        headers: {
          'Content-Type': 'application/json',
        },
        body: { invoices },
      })
      .pipe(map((res) => res)) as Observable<unknown>;
  }

  public putEditedInvoices(editedInvoice: Partial<EditedInvoice>): Observable<{ Items: EditedInvoice }> {
    const { documentId, ...invoiceWithoutFields } = editedInvoice;
    return this.http
      .put(
        `${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.INVOICE}/${encodeURIComponent(documentId!)}?edited=true`,
        { ...invoiceWithoutFields },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .pipe(map((res) => res)) as Observable<{ Items: EditedInvoice }>;
  }

  public getEditedInvoices(): Observable<{ Items: EditedInvoice[] }> {
    return this.http
      .get(`${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.INVOICE}?edited=true`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .pipe(map((res) => res)) as Observable<{ Items: EditedInvoice[] }>;
  }

  public downloadEditedInvoice(id: string): Observable<string> {
    return this.http.get(
      `${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.EDITED_INVOICES}/${id}${API_ROUTES.DOWNLOAD}`,
      {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'text',
      },
    );
  }
}
